// extracted by mini-css-extract-plugin
module.exports = {"div":"cart_counter_div__1Rxd0","counter":"cart_counter_counter__2_TY6"};